<template>
  <div class="support_requests">
    <h2>Portal User Management</h2>
    <div class="mb-2 text-left">
      <small>
        <b-button size="sm" variant="outline-primary" disabled class="mr-1">Show Details</b-button> No notes
        <b-button size="sm" variant="primary" disabled class="ml-3 mr-1">Show Details</b-button> Has notes
      </small>
    </div>
    <div class="mb-3 mt-3">
      <b-table
        ref="support_table"
        striped
        bordered
        :fields="table_fields"
        :items="support_requests"
        sort-by="submission_ts"
        :sort-desc="false"
      >
        <template #cell(show_details)="row">
          <b-button
            :variant="row.item.notes ? 'primary' : 'outline-primary'"
            size="sm"
            @click="row.toggleDetails"
            class="mr-2"
          >
            {{ row.detailsShowing ? "Hide" : "Show" }} Details
          </b-button>
        </template>

        <template #cell(complete)="data">
          <b-button @click="saveStatus(data.item)" variant="primary" size="sm" class="mr-2">
            {{  (data.item.status == 'N') ? 'Open': 'Closed' }}
          </b-button>
        </template>

        <template #row-details="row">
          <b-card>
            <b-row class="mb-2 text-left">
              <b-col><b>Comments:</b> &nbsp;{{ row.item.comments }}</b-col>
            </b-row>
            <b-row class="mb-2 text-left">
              <b-col
                ><b-button variant="primary" size="sm" @click="editNote(row.item)"
                  ><b>Notes</b></b-button
                >
                &nbsp;{{ row.item.notes }}</b-col
              >
            </b-row>
            <b-row class="mt-3 text-left">
              <b-col>
                <b>Portal Users</b>
                <b-form inline class="mt-2">
                  <label class="mr-2">PWS ID:</label>
                  <b-form-input
                    size="sm"
                    v-model="row.item.lookup_pws_id"
                    style="width: 100px"
                    class="mr-2"
                  ></b-form-input>
                  <label class="mr-2">Email:</label>
                  <b-form-input
                    size="sm"
                    v-model="row.item.lookup_email"
                    style="width: 200px"
                    class="mr-2"
                  ></b-form-input>
                  <b-button size="sm" variant="primary" @click="fetchPortalUsers(row.item)">
                    Lookup
                  </b-button>
                </b-form>
                <div v-if="row.item.portal_users && row.item.portal_users.length > 0" class="mt-2">
                  <b-table
                    small
                    bordered
                    :items="row.item.portal_users"
                    :fields="portal_user_fields"
                    :tbody-tr-class="item => getPortalUserRowClass(item, row.item)"
                  >
                    <template #cell(passcode)="data">
                      <b-button
                        size="sm"
                        variant="outline-primary"
                        @click="fetchTOTP(data.item)"
                      >{{ data.item.passcode || 'Generate' }}</b-button>
                    </template>
                  </b-table>
                </div>
                <div v-else-if="row.item.portal_users_searched" class="mt-2 text-muted">
                  No portal users found.
                </div>
              </b-col>
            </b-row>
          </b-card>
        </template>
      </b-table>
    </div>
    <b-modal id="modal-notes" size="lg" title="Notes" @ok="saveNotes">
      <b-button
        v-if="hasExistingNotes"
        variant="outline-secondary"
        size="sm"
        class="mb-2"
        @click="insertTimestamp"
      >Insert Entry</b-button>
      <b-form-textarea
        id="notes-textarea"
        ref="notesTextarea"
        v-model="notes"
        rows="10"
      ></b-form-textarea>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex"

export default {
  data() {
    return {
      hasExistingNotes: false,
      table_fields: [
        "complete",
        "show_details",
        { key: "name", label: "Name" },
        { key: "pws_id", label: "PWS ID", sortable: true },
        { key: "pws_name", label: "PWS Name" },
        { key: "email", label: "E-Mail" },
        { key: "phone", label: "Phone" },
        { key: "submission_ts", label: "Submitted", sortable: true },
        { key: "update_ts", label: "Updated", sortable: true }
      ],
      portal_user_fields: [
        { key: "active", label: "Active" },
        { key: "email", label: "E-Mail" },
        { key: "first_name", label: "First" },
        { key: "last_name", label: "Last" },
        { key: "passcode", label: "Passcode" },
        { key: "last_login_at", label: "Last Login" }
      ],
      support_requests: [],
      note_id: null,
      notes: null,
      current_sr_item: null,
      last_name: null,
      filter: null,
      filterOn: [],
      current_page: 1,
      per_page: 10
    }
  },
  computed: {
    ...mapGetters(["signed_in"]),
    userName() {
      return this.$store.state.user || "Unknown"
    }
  },
  mounted() {
    //pass
    //this.fetchUsers()
    this.fetchNewSupportRequests()
  },
  methods: {
    onSubmit(event) {
      event.preventDefault()
      //this.fetchUsers()
    },
    generateTimestampEntry() {
      const now = new Date()
      const timestamp = now.toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
      })
      return `[${this.userName} - ${timestamp}]\n`
    },
    insertTimestamp() {
      const entry = this.generateTimestampEntry()
      this.notes = entry + (this.notes || "")
    },
    editNote(item) {
      this.current_sr_item = item
      this.note_id = item.id
      const existingNotes = item.notes && item.notes.trim()
      this.hasExistingNotes = !!existingNotes
      if (existingNotes) {
        this.notes = item.notes
      } else {
        this.notes = this.generateTimestampEntry()
      }
      this.$bvModal.show('modal-notes')
    },
    async saveNotes() {
      console.log(this.notes)
      console.log('saving notes to ID ' + this.note_id)
      if (await this.syncNotes()) {
        this.current_sr_item.notes = this.notes
      }
    },
    async syncNotes() {
      const path = process.env.VUE_APP_API_URI + "/support-notes"
      try {
        console.log("saving notes")
        await this.axios.post(path, { id: this.note_id, notes: this.notes })
        return true
      } catch (error) {
        console.log(error)
        return false
      }
    },
    async saveStatus(item) {
      const path = process.env.VUE_APP_API_URI + "/support-request-status"
      try {
        let new_status = item.status == 'N' ? 'C': 'N'
        console.log("setting status")
        await this.axios.post(path, { id: item.id, status: new_status })
        item.status = new_status
      } catch (error) {
        console.log(error)
      }
    },
    async fetchNewSupportRequests() {
      const path = process.env.VUE_APP_API_URI + "/support-requests"
      try {
        console.log("fetching new support requests")
        let response = await this.axios.get(path, { params: { status: "N" } })
        if (response.data) {
          this.support_requests = response.data.support_requests.map(item => ({
            ...item,
            lookup_pws_id: item.pws_id || "",
            lookup_email: item.email || "",
            portal_users: [],
            portal_users_searched: false
          }))
        }
      } catch (error) {
        console.log(error)
      }
    },
    async fetchPortalUsers(item) {
      const path = process.env.VUE_APP_API_URI + "/portal-users"
      try {
        const params = {}
        if (item.lookup_pws_id) {
          params.pws_id = item.lookup_pws_id.trim()
        }
        if (item.lookup_email) {
          params.email = item.lookup_email.trim()
        }
        if (!params.pws_id && !params.email) {
          return
        }
        let response = await this.axios.get(path, { params })
        if (response.data) {
          item.portal_users = response.data.map(user => ({
            ...user,
            passcode: null
          }))
        } else {
          item.portal_users = []
        }
        item.portal_users_searched = true
      } catch (error) {
        console.log(error)
        item.portal_users = []
        item.portal_users_searched = true
      }
    },
    async fetchTOTP(user) {
      const path = process.env.VUE_APP_API_URI + "/portal-user-totp"
      try {
        let response = await this.axios.get(path, { params: { user_id: user.id } })
        if (response.data) {
          if (response.data.msg) {
            user.passcode = response.data.msg
          } else {
            user.passcode = response.data.code
          }
        }
      } catch (error) {
        console.log(error)
        user.passcode = "Error"
      }
    },
    getPortalUserRowClass(portalUser, supportRequest) {
      if (portalUser.email && supportRequest.email) {
        if (portalUser.email.toLowerCase() === supportRequest.email.toLowerCase()) {
          return "table-warning"
        }
      }
      return ""
    }
  }
}
</script>
<style scoped>
::v-deep .table-warning {
  background-color: #fff3cd !important;
  font-weight: bold;
}
</style>
